import { useEffect, useState } from 'react';

import styles from './styles.module.scss';

import { useRouter } from 'next/router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import MyBusinesses from '../../Account/MyBusinesses/MyBusinesses/MyBusinesses';
import CreateBusiness from '../../Account/MyBusinesses/CreateBusiness/CreateBusiness';
import LikedBusinesses from '../../Account/MyBusinesses/LikedBusinesses/LikedBusinesses';

export default function BusinessHub() {
  
  const router = useRouter();

  const [pendingRequest, setPendingRequest] = useState(false);
  const [navCategory, setNavCategory] = useState("My Businesses");

  useEffect(() => {
    if(router === null || router === undefined) return;
    if(router.query === null || router.query === undefined) return;
    if(router.query.event === null || router.query.event === undefined) return;
    if(router.query.event === 'closeCreate') {
      setNavCategory('My Businesses')
      router.replace({
        pathname: '/',
        query: null,
      }, undefined,
      { shallow: true });
    }
  }, [router.query])

  const [navDropMenu, setNavDropMenu] = useState(false);

  const changeNavCategory = (e, getNavCategory) => {
      e.preventDefault();
      if(pendingRequest === true) return;
      if(e.target.innerText !== '') {
          setNavCategory(getNavCategory);
          if(navDropMenu === true) setNavDropMenu(false);
      }
  }

  return (
    <section id={styles.wrapper}>

      <section id={styles.construction}>
        <h1>We're updating Biz Maps...</h1>
      </section>

    </section>
  )
}

/*
      <div id={styles.nav}>
        <div>
          <h1>Biz Maps</h1>
        </div>
        <div>
          <div onMouseLeave={() => { setNavDropMenu(false) }} className={styles.dropdown} >
            <button onClick={(e) => { e.preventDefault(); setNavDropMenu(navDropMenu ? false : true) }} className={styles.dropdownBtn}> <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /> {navCategory}</button>
              <div style={{display: navDropMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
              <button onClick={(e) => changeNavCategory(e, "My Businesses")}>My Businesses</button>
              <button onClick={(e) => changeNavCategory(e, "Liked Businesses")}>Liked Businesses</button>
              <button onClick={(e) => changeNavCategory(e, "Create Business")}>Create Business</button>
            </div>
          </div>
        </div>
      </div>
      <div id={styles.content}>
        { navCategory === 'My Businesses' && <MyBusinesses setNavCategory={setNavCategory} setPendingRequest={setPendingRequest} /> }
        { navCategory === 'Liked Businesses' && <LikedBusinesses setPendingRequest={setPendingRequest} /> }
        { navCategory === 'Create Business' && <CreateBusiness setNavCategory={setNavCategory} /> }
      </div>
*/